import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
// import App from './App';
import { ThemeProvider, CssBaseline } from '@mui/material';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';

import { store, persistor } from './store/configureStore';
import { PageDataProvider } from './components/PageData/PageData';
import { lightTheme } from './theme/theme';
import AllRoutes from './routes/routes';
import reportWebVitals from './reportWebVitals';
import Snackbar from './components/Snackbar.js/Snackbar';
import './styles/global.scss';

import '@fontsource/dm-sans/400.css';
import '@fontsource/dm-sans/500.css';
import '@fontsource/dm-sans/700.css';
import '@fontsource/dm-sans/900.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ThemeProvider theme={lightTheme}>
      <PageDataProvider>
        <Provider store={store}>
          <Snackbar />
          <PersistGate loading={false} persistor={persistor}>
            <CssBaseline />
            <AllRoutes />
          </PersistGate>
        </Provider>
      </PageDataProvider>
    </ThemeProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
